import useSWR from 'swr'
import { endpoints, request } from '.'

export const usePop = ({ id, type }) => {
  const { data, error, isLoading, isValidating, mutate } = useSWR(
    id ? endpoints.pop.get({ id, type }) : null,
    request
  )

  return {
    post: data?.data,
    isError: error,
    isLoading,
    mutate,
    isValidating,
  }
}
